import { getToasts } from '@/store/reducers/ToastStore';
import { Toast } from '@/components/system/Toast';

import { useSelector } from 'react-redux';

export const Toasts = () => {
  const toasts = useSelector(getToasts);

  return toasts.map((toast, index) => {
    return <Toast key={index} toast={toast} />;
  });
};
